import { Card, CardContent } from "@/components/ui/card";
import type { ExecutionMetrics as MetricsType } from "@/types/api";
import { Cpu, Clock, DollarSign, BookOpen, Quote } from "lucide-react";

interface ExecutionMetricsProps {
  metrics: MetricsType;
}

export function ExecutionMetrics({ metrics }: ExecutionMetricsProps) {
  return (
    <Card className="shadow-none border">
      <CardContent className="p-3">
        <p className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider mb-2">
          Execution Metrics
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {metrics.model && (
            <div className="flex items-center gap-2">
              <Cpu className="h-3.5 w-3.5 text-muted-foreground" />
              <div>
                <p className="text-xs font-medium">{metrics.model.split(":")[0].split(".").pop()}</p>
                <p className="text-[10px] text-muted-foreground">Model</p>
              </div>
            </div>
          )}
          {metrics.total_tokens != null && (
            <div className="flex items-center gap-2">
              <div className="text-xs">
                <p className="font-medium">{metrics.total_tokens.toLocaleString()}</p>
                {/* Sem o split gravado a linha some, em vez de virar `0↑ / 0↓`.
                    O backend passou a omitir as chaves quando o grafo não mede
                    (#867), e traduzir essa ausência para zero desfaz a
                    distinção do outro lado do fio. Zero medido continua
                    aparecendo — `0` é resposta, ausente não é. */}
                {metrics.prompt_tokens != null && metrics.completion_tokens != null && (
                  <p className="text-[10px] text-muted-foreground">
                    {metrics.prompt_tokens.toLocaleString()}↑ /{" "}
                    {metrics.completion_tokens.toLocaleString()}↓
                  </p>
                )}
              </div>
            </div>
          )}
          {metrics.latency_ms != null && (
            <div className="flex items-center gap-2">
              <Clock className="h-3.5 w-3.5 text-muted-foreground" />
              <div>
                <p className="text-xs font-medium">{(metrics.latency_ms / 1000).toFixed(1)}s</p>
                <p className="text-[10px] text-muted-foreground">Latency</p>
              </div>
            </div>
          )}
          {metrics.cost_estimate != null && (
            <div className="flex items-center gap-2">
              <DollarSign className="h-3.5 w-3.5 text-muted-foreground" />
              <div>
                <p className="text-xs font-medium">${metrics.cost_estimate.toFixed(2)}</p>
                <p className="text-[10px] text-muted-foreground">Cost</p>
              </div>
            </div>
          )}
          {metrics.retrieval_count != null && (
            <div className="flex items-center gap-2">
              <BookOpen className="h-3.5 w-3.5 text-muted-foreground" />
              <div>
                <p className="text-xs font-medium">{metrics.retrieval_count}</p>
                <p className="text-[10px] text-muted-foreground">Chunks</p>
              </div>
            </div>
          )}
          {metrics.citations_count != null && (
            <div className="flex items-center gap-2">
              <Quote className="h-3.5 w-3.5 text-muted-foreground" />
              <div>
                <p className="text-xs font-medium">{metrics.citations_count}</p>
                <p className="text-[10px] text-muted-foreground">Citations</p>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
